module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('pkHeader', {
    attrs: {
      "backmethod": _vm.backmethod,
      "rightContentPropsMain": false
    }
  }), _vm._v(" "), _c('scroll', {
    ref: "listview",
    staticClass: "listview",
    style: ({
      height: _vm.docHeigh + 'px'
    }),
    attrs: {
      "listen-scroll": _vm.listenScroll,
      "probe-type": _vm.probeType,
      "data": [_vm.tabIndex],
      "bounce": false
    }
  }, [_c('div', [_c('swiper', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto",
      "border": "none"
    },
    attrs: {
      "list": _vm.img_list,
      "auto": "",
      "height": "7.8rem",
      "dots-class": "custom-bottom",
      "dots-position": "center",
      "show-dots": false,
      "loop": true,
      "interval": 4000,
      "show-desc-mask": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pk-marquee"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/speaker.png")
    }
  }), _vm._v(" "), _c('marquee', {
    staticClass: "marquee"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.targetHref(_vm.notices[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.notices[0].tile.length > 20 ? _vm.notices[0].tile.substr(0, 10) + "..." : _vm.notices[0].tile))])])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "line-width": 2,
      "active-color": "#0d87e4",
      "custom-bar-width": "20",
      "animate": true
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('tab-item', {
      key: index,
      staticClass: "vux-center",
      attrs: {
        "selected": _vm.defaultIndex === item
      },
      on: {
        "on-item-click": function($event) {
          _vm.defaultIndex = item
        }
      }
    }, [_vm._v(_vm._s(item) + "\n            ")])
  })), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-623d8f10"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloFromVux.vue
// module id = 404
// module chunks = 1